import { Link } from "react-router-dom";
import {useRef} from 'react';
import PreampGuts from './assets/IMG_0321.jpg';
import PreampFront from './assets/IMG_0352_VSCO.jpg';
import AltoidsPreamp from './assets/IMG_0355_VSCO.jpg';
import AnalogStageModel from "./analogStageModel";
import AnalogStagePedalModel from './analogStagePedalModel';




function Shop(props) {

    return (
        <div ref={props.shopRef} style={{
            marginTop: '40px',
            //border: '1px solid black'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '20px',
                //border: '1px solid black'
            }}>
                <h1 className='title' style={{color: '#414243'}}>shop</h1>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    columnGap: '100px',
                    flexWrap: 'wrap',
                    rowGap: '100px',
                    //border: '1px solid black'
                  
                }}>
                    {props.products.map(p => (
  <Link to={p.route}
    key={p.id}
    className="productCard"
    style={{
      width: '400px',
      height: '350px',
      borderRadius: '10px',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative', // for overlay positioning
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
      //border: '1px solid black'
      // overflow: 'hidden'
    }}
  >
    {p.model}
    <div className="productCover">
      <p style={{
        color: 'black',
        fontFamily: 'monospace',
        marginTop: '225px'
       
        
      }}>{p.name}</p>
      <div style={{
        width: '80%'
      }}>
      
      </div>
    </div>
  </Link>
))}
                </div>
            </div>
            
        </div>
    )
}

export default Shop;